import { forwardRef } from "react";

import { CostTypes } from "types/enum";

import { ValueDisplay } from "commonComponents/utilities/ValueDisplay/ValueDisplay";

interface ICostTypeValueDisplayProps {
    costTypes: CostTypes[] | null | undefined;
    "data-testid": string;
    className?: string;
    allowMultiple?: boolean;
}

export const CostTypesValueDisplay = forwardRef<HTMLDivElement, ICostTypeValueDisplayProps>(
    ({ costTypes, "data-testid": dataTestId, className, allowMultiple }, ref) => {
        const displayValue = getCostTypesStringValue(costTypes, allowMultiple);
        return (
            <ValueDisplay
                ref={ref}
                data-testid={dataTestId}
                value={displayValue}
                className={className}
            />
        );
    },
);

export const getCostTypesStringValue = (
    costTypes: CostTypes[] | null | undefined,
    allowMultiple?: boolean,
): string => {
    let costTypesValue: CostTypes[] = [];
    if (costTypes && costTypes.length > 0) {
        costTypesValue = [...costTypes];
    }
    if (!allowMultiple) {
        // If not allowing multiple, return the first cost type only
        return CostTypes[costTypesValue[0] ?? CostTypes.None];
    }
    return costTypesValue.map((costType) => CostTypes[costType]).join(", ");
};
